"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var theme=require("../styles/theme.js");const SIZE={medium:theme.theme.customHeights.regularButton,small:theme.theme.customHeights.smallButton};exports.SIZE=SIZE;
//# sourceMappingURL=constants.js.map
